import { render, staticRenderFns } from "./GamesTabs.vue?vue&type=template&id=7c9ab3e0&"
import script from "./GamesTabs.vue?vue&type=script&lang=js&"
export * from "./GamesTabs.vue?vue&type=script&lang=js&"
import style0 from "./GamesTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports